import { render, staticRenderFns } from "@/style-guide/partials/flat-selector-switch/flat-selector-switch.pug?vue&type=template&id=7881f012&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=7881f012&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881f012",
  null
  
)

export default component.exports